<!-- 在线缴费 -->
<template>
    <div class="el-pay">
        <el-row class="page_content">
            <h1 class="head_title">在线缴费</h1>
            <el-table
                :data="tableData"
                border
                style="width: 100%;">
                <el-table-column
                    prop="title"
                    header-align="center"
                    align="center"
                    label="缴费名称">
                </el-table-column>
                <el-table-column
                    prop="title"
                    header-align="center"
                    align="center"
                    label="缴费金额">
                </el-table-column>
                <el-table-column
                    prop="title"
                    header-align="center"
                    align="center"
                    label="缴费状态">
                </el-table-column>
                <el-table-column
                    prop="title"
                    header-align="center"
                    align="center"
                    label="缴费">
                    <template slot-scope="scope">
                      <el-link :underline="false" v-show="scope.row.xq === '1'" @click="seeQRCode(scope.$index)" type="primary">支付</el-link>
                      <el-link :underline="false" v-show="scope.row.xq != '1'" disabled>已支付</el-link>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <el-dialog width="400px" :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="">
          <span slot="footer" class="dialog-footer"></span>
        </el-dialog>
    </div>
</template>
<script>
export default {
  name: "Pay",
  data() {
    return {
        tableData: [],
        dialogImageUrl: '',
        dialogVisible: false
    };
  },
  created() {
   
  },
  methods: {
    seeQRCode(index){
        this.dialogVisible =true;
        this.dialogImageUrl = this.tableData[index].url;
    }
  }
};
</script>
<style  lang="less">
  @import '../../styles/base.less';
  .el-pay{
    .wd{
        color: @red;
    }
    // .el-dialog__body{
    //     border-top:1px solid #ebeef5;
    // }
  }
</style>


// WEBPACK FOOTER //
// src/pages/onlinePayment/Pay.vue